import Vue from "vue";
import Router from "vue-router";
import axios from 'axios';

import store from './store';
//import Home from './components/home.vue'

Vue.use(Router);

//export default new Router({
const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      //name: 'navigation',
      //component: Home
      component: (resolve) => require(["@/components/menu"], resolve),
      children: [
        {
          path: "/",
          name: "home",
          component: (resolve) => require(["@/components/home"], resolve),
          meta: { keepAlive: true, },
        },
        {
          path: "/aboutUs",
          name: "aboutUs",
          component: (resolve) => require(["@/components/aboutUs"], resolve),
          meta: { hideMobileHeader: true },
        },
        {
          path: "/brandList",
          name: "brandList",
          component: (resolve) => require(["@/components/brandList"], resolve),
          meta: { keepAlive: true, },
        },
        {
          path: "/admin",
          name: "admin",
          component: (resolve) => require(["@/components/admin"], resolve),
          meta: { keepAlive: false, },
        },
        {
          path: "/brandProductList/:code",
          name: "brandProductList",
          component: (resolve) => require(["@/components/brandProductList"], resolve),
          meta: { keepAlive: true, hideMobileHeader: true },
        },
        {
          path: "/classifyList/:code?",
          name: "classifyList",
          component: (resolve) => require(["@/components/classifyList"], resolve),
          meta: { keepAlive: true, },
        },
        {
          path: "/classifyProductList/:code",
          name: "classifyProductList",
          component: (resolve) => require(["@/components/classifyProductList"], resolve),
          meta: { keepAlive: true },
        },
        {
          path: "/hotProductList",
          name: "hotProductList",
          component: (resolve) => require(["@/components/hotProductList"], resolve),
          meta: { keepAlive: true, hideMobileHeader: true, hideMobileFooterNav: true },
        },
        {
          path: "/newProductList",
          name: "newProductList",
          component: (resolve) => require(["@/components/newProductList"], resolve),
          meta: { keepAlive: true, hideMobileHeader: true, hideMobileFooterNav: true },
        },
        {
          path: "/promoProductList",
          name: "promoProductList",
          component: (resolve) => require(["@/components/promoProductList"], resolve),
          meta: { keepAlive: true, hideMobileHeader: true, hideMobileFooterNav: true },
        },
        {
          path: "/productList",
          name: "productList",
          component: (resolve) => require(["@/components/productList"], resolve),
          meta: { keepAlive: true, hideMobileHeader: true, hideMobileFooterNav: true },
        },
        {
          path: "/product/:code",
          name: "product",
          component: (resolve) => require(["@/components/product"], resolve),
          meta: { hideMobileHeader: true, hideMobileFooterNav: true },
        },
        {
          path: "/member",
          name: "member",
          component: (resolve) => require(["@/components/member"], resolve),
          meta: { hideMobileFooter: true },
        },
        {
          path: "/login",
          name: "login",
          component: (resolve) => require(["@/components/login"], resolve),
          meta: { hideMobileHeader: true, hideMobileFooter: true },
        },
        {
          path: "/register",
          name: "register",
          component: (resolve) => require(["@/components/register"], resolve),
          meta: { hideMobileHeader: true },
        },
        {
          path: "/recoverPassword",
          name: "recoverPswd",
          component: (resolve) => require(["@/components/recoverPassword"], resolve),
          meta: { hideMobileHeader: true },
        },
        {
          path: "/shoppingCart",
          name: "shoppingCart",
          component: (resolve) => require(["@/components/shoppingCart"], resolve),
          meta: { requiresAuth: true, hideMobileFooter: true, hideMobileFooterNav: true },
        },
        {
          path: "/checkout",
          name: "checkout",
          component: (resolve) => require(["@/components/checkOut"], resolve),
          meta: { requiresAuth: true, hideMobileHeader: true, hideMobileFooter: true, hideMobileFooterNav: true },
        },
        {
          path: "/orderConfirmed",
          name: "orderConfirmed",
          component: (resolve) => require(["@/components/orderConfirmed"], resolve),
          meta: { hideMobileHeader: true, hideMobileFooter: true, hideMobileFooterNav: true },
        },
        {
          path: "/orderHistory",
          name: "orderHistory",
          component: (resolve) => require(["@/components/orderHistory"], resolve),
          meta: { requiresAuth: true, hideMobileFooter: true },
        },
        {
          path: "/cardPayment",
          name: "cardPayment",
          component: (resolve) => require(["@/components/xPaymentCard"], resolve),
          meta: { requiresAuth: true, hideMobileFooter: true },
        },
      ],
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      document.body.scrollTop = 0;  // For Safari
      document.documentElement.scrollTop = 0;
      // return { x: 0, y: 0 }
    }
  }
});

let ahttp = axios.create({
  baseURL: store.state.ioBaseURL,
  withCredentials: true,
});

router.beforeEach(async (to, from, next) => {
  if (to.matched.some(route => route.meta.requiresAuth)) {
    if (store.state.member && store.state.member.SessionToken) {
      next();
    } else {
      let token = localStorage.getItem("SessionToken");
      if (token) {
        let obj = { SessionToken: token };
        await ahttp
          .post("GetMember", obj, {
            headers: { "Content-Type": "application/json;charset=UTF-8" },
          })
          .then((rpdata) => {
            if (rpdata.data.meta.code == "200") {
              store.commit("member", rpdata.data.data);
              next();
            } else {
              next({ name: "member" })
            }
          })
          .catch((err) => { }); // eslint-disable-line
      } else {
        next({ name: "member" })
      }
    }
  } else {
    next();
  }
});
//.catch(err => {}); // eslint-disable-line

export default router;
